import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIconWrapper } from '@icon/fontawesome/FontAwesomeIconWrapper';
import MediaThumb from './MediaThumb';
import { mediaValueName } from './mediaLibrary';
/**
 * @export
 * One picked value: a fixed 4rem chip with a remove badge, shown under a field,
 * above the upload drop-zone, or stacked in the browse dialog's selection
 * column. `MediaThumb` decides how the value itself is drawn.
 *
 * @advanced
 */
const MediaStripCard = ({ value, name, onRemove, removeTitle }) => {
    const label = name !== null && name !== void 0 ? name : mediaValueName(value);
    return _jsxs("div", { className: "uxpcore_mediapicker__strip-card", title: label, children: [_jsx("div", { className: "uxpcore_mediapicker__strip-thumb", children: _jsx(MediaThumb, { value: value, name: name }) }), onRemove &&
                _jsx("span", { className: "uxpcore_mediapicker__strip-remove", title: removeTitle, onClick: onRemove, children: _jsx(FontAwesomeIconWrapper, { icon: ['fal', 'times'] }) })] });
};
export default MediaStripCard;
